import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy WordPress test page — permanently redirect to the homepage.
export const Route = createFileRoute("/formidable-test-page-1")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
